import { AccountMultipleRemoveOutlineIcon } from './AccountMultipleRemoveOutlineIcon';

/**
 * author: Michael Richins
 * id 618B092A-7228-4E70-A95C-7EB4EC1BA2FB
 * name account-multiple-remove-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-remove-outline.svg
 * tags
 * - Account / User 
 */
export const PersonMultipleRemoveOutlineIcon = AccountMultipleRemoveOutlineIcon;
export default PersonMultipleRemoveOutlineIcon